export const pinMass = 3
export const ballMass = 15
export const pinSpace = 2.5
export const moveEvent = 'move'